import { render, staticRenderFns } from "./selectNoticeTemplateModel.vue?vue&type=template&id=44a90caf"
import script from "./selectNoticeTemplateModel.vue?vue&type=script&lang=js"
export * from "./selectNoticeTemplateModel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('44a90caf')) {
      api.createRecord('44a90caf', component.options)
    } else {
      api.reload('44a90caf', component.options)
    }
    module.hot.accept("./selectNoticeTemplateModel.vue?vue&type=template&id=44a90caf", function () {
      api.rerender('44a90caf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/administrators/accountManage/selectNoticeTemplateModel.vue"
export default component.exports